import React from "react";
import { FooterContainer } from "./index.styles";

export function Footer() {
  return (
    <footer>
      <FooterContainer>&copy; 2024 North Store</FooterContainer>
    </footer>
  );
}
